class CountdownTimer {
  constructor(containerId) {
    this.container = document.getElementById(containerId);
    this.date = this.container.dataset.date;
    this.time = this.container.dataset.time;
    this.targetTime = new Date(`${this.date}T${this.time}:00`).getTime();

    this.daysEl = this.container.querySelector("#days span");
    this.hoursEl = this.container.querySelector("#hours span");
    this.minutesEl = this.container.querySelector("#minutes span");
    this.secondsEl = this.container.querySelector("#seconds span");

    this.init();
  }

  init() {
    this.update();
    this.timer = setInterval(() => this.update(), 1000);
  }

  update() {
    const now = new Date().getTime();
    const distance = this.targetTime - now;

    if (distance <= 0) {
      this.daysEl.innerHTML = "00";
      this.hoursEl.innerHTML = "00";
      this.minutesEl.innerHTML = "00";
      this.secondsEl.innerHTML = "00";
      clearInterval(this.timer);
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    this.daysEl.innerHTML = this.pad(days);
    this.hoursEl.innerHTML = this.pad(hours);
    this.minutesEl.innerHTML = this.pad(minutes);
    this.secondsEl.innerHTML = this.pad(seconds);
  }

  pad(num) {
    return num < 10 ? `0${num}` : num;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new CountdownTimer('countdown');
});